import {
  ValorationPatientScheduledAssessment,
  ValorationPatientAssessmentMade,
} from "./";

export const ValorationPatient = ({
  id,
  state,
  numberEvents,
  protocol,
  scheduleEventId,
  procedure,
  clearanceStatus,
  clearanceNote,
}) => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      {state === "QUIZ_ANSWERED" && (
        <h6 className="mb-0">Opción no disponible</h6>
      )}
      {(state === "SCHEDULED_ASSESSMENT" ||
        state === "RESCHEDULED_ASSESSMENT") && (
        <ValorationPatientScheduledAssessment
          patientSurgeryId={id}
          scheduleEventId={scheduleEventId}
          procedure={procedure}
        />
      )}
      {(state === "ASSESSMENT_MADE" ||
        state === "ASSESSMENT_MADE_RESCHEDULE" ||
        state === "QUIZ_SATISFACTION_ANSWERED" ||
        state === "SCHEDULED_ASSESSMENT_FINAL" ||
        state === "FINISHED") && (
        <ValorationPatientAssessmentMade
          numberEvents={numberEvents}
          protocol={protocol}
          clearanceStatus={clearanceStatus}
          clearanceNote={clearanceNote}
        />
      )}
    </>
  );
};
